/* global Swiper */
// *******************************************************************************
// Our Companies
// *******************************************************************************

const ourCompaniesSliderElements = document.querySelectorAll('[data-slider="our-companies-slider"]');

const ourCompaniesSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  watchOverflow: true,
  watchSlidesVisibility: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  allowTouchMove: false,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on: {
    slideChange() {
      const activeSlide = this.slides[this.activeIndex];
      const activeVideo = activeSlide.querySelector('video');

      if (activeVideo) {
        activeVideo.currentTime = 0;
        activeVideo.play();
      }
    },
  },
};

ourCompaniesSliderElements.forEach((el) => {
  const ourCompaniesSliderParent = el.closest('.our-companies');
  const ourCompaniesSliderEle = ourCompaniesSliderParent.querySelector('.our-companies-slider');
  const sliderAutoplayDelay = ourCompaniesSliderEle.getAttribute('data-swiper-delay');

  if (sliderAutoplayDelay) {
    ourCompaniesSliderOptions.autoplay = {
      delay: sliderAutoplayDelay,
    };
  }

  const ourCompaniesSlider = new Swiper(el, ourCompaniesSliderOptions);
});
